import { combineReducers } from 'redux';

import appliedSearchFilters from 'redux/appliedSearchFilters/reducers';
import advancedSearch from 'redux/advancedSearch/reducers';

import constants from './constants';

export const defaultState = {
  data: [],
  dataError: false,
  paginator: {},
  sort: {},
  ui: {
    isDeleting: false,
    isLoadingData: true,
    isInitialLoading: true,
    toResetSelectedItems: true,
  },
};

function lookUp(state = defaultState, action) {
  switch (action.type) {
    case constants.FETCH_DATA_REQUEST:
      return {
        ...state,
        dataError: false,
        sort: {},
        ui: {
          ...state.ui,
          isLoadingData: true,
          toResetSelectedItems: false,
        },
      };
    case constants.FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        dataError: action.error,
        paginator: action.paginator,
        sort: action.sort,
        ui: {
          ...state.ui,
          isInitialLoading: false,
          isLoadingData: false,
          toResetSelectedItems: action.toResetSelectedItems,
        },
      };
    case constants.DELETE_DATA_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          isDeleting: true,
          toResetSelectedItems: false,
        },
      };
    case constants.DELETE_DATA_SUCCESS:
      return {
        ...state,
        data: state.data.filter(({ id }) => action && action.payload && !action.payload.includes(id)),
        dataError: action.error,
        ui: {
          ...state.ui,
          isDeleting: false,
          toResetSelectedItems: true,
        },
      };
    default:
      return state;
  }
}

export default combineReducers({
  appliedSearchFilters,
  advancedSearch,
  lookUp,
});
